export default "__VITE_ASSET__8Z1hPtP1__";